import React, { useState } from "react";
import { Invoices } from "./Invoices";
import { PaymentMethods } from "./PaymentMethods";
export const PaymentsNew = () => {
  const [view, setView] = useState(true);
  return (
    <React.Fragment>
      <div style={{ paddingInline: "2rem" , marginBottom:"1rem", display:"flex"}}>
        <button
          className="savebutton"
          style={{
            textAlign: "center",
            fontSize: "14px",
            fontWeight: "600",
            padding: "12px 20px",
            opacity:view ? "1": "0.3",
          }}
          onClick={() => {
            console.log("clicked", view);
            setView(!view);
          }}
        >
          View Invoices
        </button>
        <button
        className="savebutton"
        style={{
          textAlign: "center",
          fontSize: "14px",
          fontWeight: "600",
          padding: "12px 20px",
          opacity:view ? "0.3": "1",
        }}
        onClick={() => {
          console.log("clicked", view);
          setView(!view);
        }}
      >
        View Payment Methods
      </button>
      </div>
      {view ? <PaymentMethods /> : <Invoices />}
    </React.Fragment>
  );
};
